"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const typography_1 = require("../styles/typography");
const Badge = ({ color, style, text }) => {
    let container = Object.assign({}, typography_1.bold, typography_1.text, { lineHeight: '16px', fontSize: 13, display: 'inline-block', color: color, textTransform: 'uppercase' }, style);
    return React.createElement("div", { style: container }, text);
};
exports.default = Badge;
